import {Roles} from "@/enum/roles";
import {taskNames, taskLinks, taskTypes} from "@/enum/task_type";
import Create from "@/app/tasks/moveProducts/MoveProductsCreate.view";
import Show from "@/app/tasks/moveProducts/MoveProductsShow.view";

const type = taskTypes.MOVE_PRODUCTS;
const BASE_URL = taskLinks[type];

const routes = {
    create: {
        path: BASE_URL + '/create',
        component: Create,
        meta: {
            title: 'tasks.moveProducts.create',
            requireRole: [Roles.CHIEF],
            getParent: () => '/'
        }
    },
    show: {
        path: BASE_URL + '/:taskId(\\d+)',
        component: Show,
        meta: {
            title: taskNames[type],
            requireRole: [Roles.STOREKEEPER, Roles.CHIEF],
            getParent: () => '/',
            trackTime: true
        }
    }
};

export default Object.values(routes);
